// Action types
export const SET_WINDOW_SIZE = 'mpa/window-resize/SET_WINDOW_SIZE';
